import {SharedQuestion} from "./SharedQuestion";

export class LikertScaleSharedQuestion extends SharedQuestion {

    protected value:IValue;

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        if (!this.question.required) {
            return true;
        }

        return this.isEmpty();
    }

    isEmpty():boolean {
        return this.value != null;
    }

    validationMessage():string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'likert_validation_message';
    }

    getValue():IValue {
        return this.value;
    }

    setValue(value:IValue) {
        this.value = value;
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        let currentValue = currentValues[0];

        return currentValue.choice === value.choice && currentValue.value === value.value;
    }
}